/*
 * @fileOverView Aside component definition
 */

import Vue from 'vue';
import stickybits from 'stickybits'
import ViewportHelper from 'utils/ViewportHelper';
import { Events } from 'utils/Constants';
import Throttle from 'utils/Throttle';

/**
 * [Aside Vue]
 * @type {class}
 */
Vue.component('aside-vue', {

  data: function() {
    return {
      stickyCallback: null,
      stickyBit: null
    }
  },

  mounted() {
    // jQuery makes getting the proper dimensions (with/without padding) easier.
    this.$asideParent = $(this.$refs.aside.parentNode);
    this.$aside = $(this.$refs.aside);

    this.stickyCallback = Throttle(e => this.updateSticky(), 200);
    window.addEventListener(Events.RESIZE, this.stickyCallback);
    window.addEventListener(Events.SCROLL, this.stickyCallback);
    this.updateSticky();
  },

  destroyed() {
    window.removeEventListener(Events.RESIZE, this.stickyCallback);
    window.removeEventListener(Events.SCROLL, this.stickyCallback);
  },

  methods: {
    /**
     * Determines whether or not sticky behavior should be applied.
     *
     * Prevents calculation and display issues when the content on the left side
     * of the page isn't tall enough to stretch the sidebar any taller than it
     * already is. There is no need to stick in that situation.
     *
     * @method shouldSticky
     * @public
     */
    shouldSticky() {
      return this.$asideParent.height() > this.$aside.outerHeight();
    },

    /**
     * Updates or removes stickyBits instance based on browser size
     *
     * @method updateSticky
     * @public
     */
    updateSticky() {
      if (ViewportHelper.isLargeDesktop() && this.shouldSticky()) {
        if (this.stickyBit) {
          this.stickyBit.update();
        } else {
          this.stickyBit = stickybits(this.$refs.aside,{
            useStickyClasses: true,
            useFixed: true
          });
        }
      }
      else if (this.stickyBit) {
        this.stickyBit.cleanup();
        this.stickyBit = null;
      }
    }
  }
});
